import EInvoiceSetting from "./e-invoice/EInvoiceSetting.vue";
import TicketSetting from "./ticket/TicketSetting.vue";

export default {
  name: 'EInvoiceDetailSetting',
  components: {
    EInvoiceSetting,
    TicketSetting,
  },
  data() {
    return {
      eInvoiceDetailOptions: [
        {
          DetailId: '1',
          Keyword: 'Hóa đơn điện tử',
        },
        {
          DetailId: '2',
          Keyword: 'Vé'
        }
      ],
      lv2Active: null,
    }
  },
  methods: {
    setLv2Active(detailId) {
      this.lv2Active = detailId;
    }
  },
  computed: {

  }
}